import { NgxSpinnerService } from "ngx-spinner";
import { NgxIndexedDBService } from "ngx-indexed-db";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ICMenu } from "../models/entities/icmenu";
import { ICMenuFilter } from "../models/filters/icmenu.filter";
import { ICMenuApi } from "../models/apis/icmenu.api";
import { BaseDataService } from "./shared/base.data.service";

@Injectable()
export class ICMenuService extends BaseDataService<
  ICMenu,
  ICMenuFilter,
  ICMenuApi
> {
  constructor(
    public dbSrv: NgxIndexedDBService,
    public spinner: NgxSpinnerService,
    public http: HttpClient,
  ) {
    super(dbSrv, spinner, http, ICMenu);
    this.EndPoint = "icmenu";
  }
}
